module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fillcontain"
  }, [_c('div', {
    staticClass: "navCalss",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("| 员工列表")]), _vm._v(" "), _c('div', {
    staticClass: "search_container"
  }, [_c('el-form', {
    ref: "search_data",
    staticClass: "demo-form-inline search-form",
    attrs: {
      "inline": true,
      "model": _vm.search_data,
      "size": "medium"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "登录名:"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入真实姓名"
    },
    model: {
      value: (_vm.searchData.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWord", $$v)
      },
      expression: "searchData.keyWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getAdminList('1')
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "btnRight"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "view"
    },
    on: {
      "click": function () {
        _vm.searchData = {
          keyWord: ''
        };
        _vm.getAdminList();
      }
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "btnRight"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAddAdmin()
      }
    }
  }, [_vm._v("创建员工")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": "",
      "size": "medium"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adminId",
      "label": "序号",
      "align": "center",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "用户名",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "真实姓名",
      "align": "center",
      "min-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.realName) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号",
      "min-width": "200px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operation",
      "align": "center",
      "label": "操作",
      "fixed": "right",
      "min-width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onEditAdmin(scope.row, '2')
            }
          }
        }, [_vm._v("查看")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onEditAdmin(scope.row)
            }
          }
        }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onEditAdmin(scope.row, '3')
            }
          }
        }, [_vm._v("修改密码")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onDelAdmin(scope.row.adminId)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("删除")])])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.dialog.showC,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showC", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    ref: "netBarForm",
    staticStyle: {
      "margin": "20px",
      "width": "auto"
    },
    attrs: {
      "model": _vm.employee.netBarForm,
      "rules": _vm.employee.form_rules,
      "label-width": _vm.employee.formLabelWidth,
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "密码:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入密码",
      "type": "password"
    },
    model: {
      value: (_vm.employee.netBarForm.password),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "password", $$v)
      },
      expression: "employee.netBarForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "passwordA",
      "label": "确认密码:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请再输入一次密码",
      "type": "password"
    },
    model: {
      value: (_vm.employee.netBarForm.passwordA),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "passwordA", $$v)
      },
      expression: "employee.netBarForm.passwordA"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onsumbitB()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.showC = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialog.title,
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    ref: "netBarForm",
    staticStyle: {
      "margin": "20px",
      "width": "auto"
    },
    attrs: {
      "model": _vm.employee.netBarForm,
      "rules": _vm.employee.form_rules,
      "label-width": _vm.employee.formLabelWidth,
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "userName",
      "label": "账户名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入账户名称"
    },
    model: {
      value: (_vm.employee.netBarForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "userName", $$v)
      },
      expression: "employee.netBarForm.userName"
    }
  })], 1), _vm._v(" "), (_vm.showOnsub) ? _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "密码:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入密码",
      "type": "password"
    },
    model: {
      value: (_vm.employee.netBarForm.password),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "password", $$v)
      },
      expression: "employee.netBarForm.password"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showOnsub) ? _c('el-form-item', {
    attrs: {
      "prop": "passwordA",
      "label": "确认密码:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请再输入一次密码",
      "type": "password"
    },
    model: {
      value: (_vm.employee.netBarForm.passwordA),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "passwordA", $$v)
      },
      expression: "employee.netBarForm.passwordA"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "真实姓名:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入真实姓名"
    },
    model: {
      value: (_vm.employee.netBarForm.realName),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "realName", $$v)
      },
      expression: "employee.netBarForm.realName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "mobile",
      "label": "手机:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    on: {
      "keyup": function($event) {
        this.value = this.value.replace(/[^\d]/g, '')
      }
    },
    model: {
      value: (_vm.employee.netBarForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "mobile", $$v)
      },
      expression: "employee.netBarForm.mobile"
    }
  })], 1), _vm._v(" "), (_vm.showOnsub) ? _c('el-form-item', {
    attrs: {
      "prop": "roleId",
      "label": "角色类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请选择角色类型"
    },
    model: {
      value: (_vm.employee.netBarForm.roleId),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "roleId", $$v)
      },
      expression: "employee.netBarForm.roleId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "系统管理员",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "快递点管理员",
      "value": 4
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 150px"
    }
  }, [(_vm.showOnsub) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onsumbit()
      }
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    class: _vm.showOnsub ? '' : 'margiLeft',
    on: {
      "click": function($event) {
        _vm.dialog.show = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showB,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showB", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定删除该员工信息？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem(_vm.indexA)
      }
    }
  }, [_vm._v("移除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.showB = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58b13e44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/personnel/adminList.vue
// module id = 1242
// module chunks = 2